// app/redux/sagas/leaveRequestsSaga.js

import {  call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import axios from "axios";

import {
    GET_MY_LEAVE_REQUESTS_REQUEST,
    GET_MANAGER_INBOX_REQUEST,
    GET_ADMIN_INBOX_REQUEST,
    GET_MANAGER_HISTORY_REQUEST,
    setLeaveRequestLoading,
    getMyLeaveRequestsSuccess,
    getMyLeaveRequestsFail,
    createLeaveRequestSuccess,
    createLeaveRequestFail,
    getManagerInboxSuccess,
    getManagerInboxFail,
    managerDecisionSuccess,
    managerDecisionFail,
    managerDelegateToAdminSuccess,
    managerDelegateToAdminFail,
    getManagerHistorySuccess,
    getManagerHistoryFail,
    getManagerTeamLeavesRequest,
    getManagerTeamLeavesSuccess,
    getManagerTeamLeavesFail,
    getCompanyCalendarLeavesSuccess,
    getCompanyCalendarLeavesFail,
    getAdminInboxSuccess,
    getAdminInboxFail,
    adminDecisionSuccess,
    adminDecisionFail,
    POSTPONE_LEAVE_REQUEST_SUCCESS,
    POSTPONE_LEAVE_REQUEST_FAIL,
    postponeLeaveRequestSuccess,
    postponeLeaveRequestFail,
    UPLOAD_LEAVE_JUSTIFICATIFS_REQUEST,
    uploadLeaveJustificatifsRequest,
    uploadLeaveJustificatifsSuccess,
    uploadLeaveJustificatifsFail,
    GET_ALL_LEAVE_REQUESTS_REQUEST,
    getAllLeaveRequestsSuccess,
    getAllLeaveRequestsFail,
    EXPORT_LEAVE_REQUESTS_EXCEL_REQUEST,
    exportLeaveRequestsExcelSuccess,
    exportLeaveRequestsExcelFail,
    ADJUST_LEAVE_REQUEST_PERIOD_REQUEST,
    adjustLeaveRequestPeriodSuccess,
    adjustLeaveRequestPeriodFail,
} from "../actions/leaveRequestsActions";

import {API_BASE_URL, extractErrorMessage, getRequest, postRequest} from "../../../api";

// const getUidHeader = () => {
//     const uid = sessionStorage.getItem("uid");
//     return uid ? String(uid) : "";
// };

// const extractErrorMessage = (error, fallback) => {
//     // backend: {timestamp,status,error,message,path,details}
//     const data = error?.response?.data;
//
//     if (data?.message) return String(data.message);
//     if (data?.error) return String(data.error);
//     if (error?.message) return String(error.message);
//
//     // si c'est un objet sans message => stringify safe
//     try {
//         if (data && typeof data === "object") return JSON.stringify(data);
//     } catch {}
//     return fallback;
// };

// ===================== WORKERS =====================
export function* getMyLeaveRequestsSaga(action) {
    const url = `${API_BASE_URL}/api/leave-requests/requests/mine`;
    const token = sessionStorage.getItem("token");
        const uid = sessionStorage.getItem("uid");


    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyLeaveRequestsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes");
        yield put(getMyLeaveRequestsFail(msg));
    } finally {
        if (!silent) yield put(setLeaveRequestLoading(false));
    }
}

export function* createLeaveRequestSaga(action) {
    const url = `${API_BASE_URL}/api/leave-requests/requests`;
    const token = sessionStorage.getItem("token");
        const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    Swal.fire({
        title: "Création des demandes en cours…",
        text: "Veuillez patienter.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
    });
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: action.payload,
            headers: { uid },
        });

        yield put(createLeaveRequestSuccess(resp.data));

        // Si des justificatifs sont présents dans l'action d'origine
        const requestId = resp.data?.id;
        const files = [];
        if (action.payload.justificatif) files.push(action.payload.justificatif);
        if (action.payload.autorisation) files.push(action.payload.autorisation);

        if (requestId && files.length > 0) {
            yield put(uploadLeaveJustificatifsRequest({ requestId, files }));
        }

        Swal.close();
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande envoyée avec succès",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_LEAVE_REQUESTS_REQUEST });
        yield put({ type: GET_ALL_LEAVE_REQUESTS_REQUEST });
        
        // Optionnel : Rafraîchir aussi les soldes et mouvements car l'admin vient d'en créer un
        yield put({ type: "GET_ALL_COMPANY_SOLDES_REQUEST" });
        yield put({ type: "GET_ALL_MOVEMENTS_REQUEST" });

    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande");
        yield put(createLeaveRequestFail(msg));

        Swal.close();
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* getManagerInboxSaga(action) {
    const url = `${API_BASE_URL}/api/leave-requests/manager/inbox`;
    const token = sessionStorage.getItem("token");
        const uid = sessionStorage.getItem("uid");


    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox manager");
        yield put(getManagerInboxFail(msg));
    } finally {
        if (!silent) yield put(setLeaveRequestLoading(false));
    }
}

export function* getManagerHistorySaga(action) {
    const url = `${API_BASE_URL}/api/leave-requests/manager/history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerHistorySuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement historique manager");
        yield put(getManagerHistoryFail(msg));
    } finally {
        if (!silent) yield put(setLeaveRequestLoading(false));
    }
}

export function* getManagerTeamLeavesSaga() {
    const url = `${API_BASE_URL}/api/leave-requests/manager/team-leaves`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getManagerTeamLeavesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement congés équipe");
        yield put(getManagerTeamLeavesFail(msg));
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* getCompanyCalendarLeavesSaga() {
    const url = `${API_BASE_URL}/api/leave-requests/calendar/company-leaves`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getCompanyCalendarLeavesSuccess(resp.data || []));
    } catch (error) {
        yield put(getCompanyCalendarLeavesFail(extractErrorMessage(error, "Erreur chargement calendrier partagé")));
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* managerDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
        const uid = sessionStorage.getItem("uid");


    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-requests/manager/requests/${id}/decision`;

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { approved, comment },
            headers: { uid },
        });

        yield put(managerDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_MANAGER_INBOX_REQUEST });
        yield put({ type: GET_MANAGER_HISTORY_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision manager");
        yield put(managerDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* managerDelegateToAdminSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const { id } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-requests/manager/requests/${id}/delegate-to-admin`;

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: {},
            headers: { uid },
        });

        yield put(managerDelegateToAdminSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Traitement transmis à l'Admin RH",
            timer: 1600,
            showConfirmButton: false,
        });

        yield put({ type: GET_MANAGER_INBOX_REQUEST });
        yield put({ type: GET_ADMIN_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur délégation vers RH");
        yield put(managerDelegateToAdminFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* getAdminInboxSaga(action) {
    const url = `${API_BASE_URL}/api/leave-requests/admin/inbox`;
    const token = sessionStorage.getItem("token");
        const uid = sessionStorage.getItem("uid");


    const silent = action?.meta?.silent === true;
    if (!silent) yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAdminInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox RH");
        yield put(getAdminInboxFail(msg));
    } finally {
        if (!silent) yield put(setLeaveRequestLoading(false));
    }
}

export function* adminDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
        const uid = sessionStorage.getItem("uid");


    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-requests/admin/requests/${id}/decision`;

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { approved, comment },
            headers: { uid },
        });

        yield put(adminDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision RH envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({ type: GET_ADMIN_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision RH");
        yield put(adminDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}


export function* uploadLeaveJustificatifsSaga(action) {
    const { requestId, files } = action.payload;
    const url = `${API_BASE_URL}/api/leave-requests/requests/${requestId}/justificatifs`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const formData = new FormData();
    files.forEach((file) => {
        formData.append("files", file);
    });

    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: formData,
            headers: {
                uid,
                "Content-Type": "multipart/form-data",
            },
        });

        yield put(uploadLeaveJustificatifsSuccess(resp.data));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de l'envoi des justificatifs");
        yield put(uploadLeaveJustificatifsFail(msg));
    }
}

export function* postponeLeaveRequestSaga(action) {
    const { id, startDate, endDate } = action.payload || {};
    const url = `${API_BASE_URL}/api/leave-requests/requests/${id}/postpone`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { startDate, endDate },
            headers: { uid },
        });

        yield put(postponeLeaveRequestSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande de report envoyée",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_LEAVE_REQUESTS_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur report de la demande");
        yield put(postponeLeaveRequestFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* getAllLeaveRequestsSaga() {
    const url = `${API_BASE_URL}/api/leave-requests/admin/all-history`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getAllLeaveRequestsSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement toutes les demandes");
        yield put(getAllLeaveRequestsFail(msg));
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

// ===================== EXPORT EXCEL =====================
export function* exportLeaveRequestsExcelSaga(action) {
    const { source } = action.payload;
    const url = `${API_BASE_URL}/api/leave-requests/export-excel?source=${source}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(axios.get, url, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${token}`,
                uid,
            },
        });

        // Trigger download
        const blob = new Blob([resp.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `demandes_conges_${source}_${new Date().getTime()}.xlsx`;
        link.click();

        yield put(exportLeaveRequestsExcelSuccess());
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur export Excel");
        yield put(exportLeaveRequestsExcelFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

export function* adjustLeaveRequestPeriodSaga(action) {
    const { id, startDate, endDate, dateReprise } = action.payload;
    const url = `${API_BASE_URL}/api/leave-requests/admin/requests/${id}/adjust-period`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setLeaveRequestLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: { startDate, endDate, dateReprise },
            headers: { uid },
        });

        yield put(adjustLeaveRequestPeriodSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Ajustement réussi",
            text: "La période de congé a été mise à jour et le solde de l'employé a été réajusté.",
            timer: 2000,
            showConfirmButton: false,
        });

        // Rafraîchir les listes
        yield put({ type: GET_ADMIN_INBOX_REQUEST });
        yield put({ type: GET_ALL_LEAVE_REQUESTS_REQUEST });
        yield put({ type: "GET_ALL_COMPANY_SOLDES_REQUEST" });
        yield put({ type: "GET_ALL_MOVEMENTS_REQUEST" });

    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de l'ajustement");
        yield put(adjustLeaveRequestPeriodFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: msg,
        });
    } finally {
        yield put(setLeaveRequestLoading(false));
    }
}

